import { RegistrationStatusEnum as ProgressStatus } from "@/api-v2/course/models/registration";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export const learningStatus = (item: string) => {
  if (item === "not_processed") return i18n.tc(LocalesFields.NotProcessed);
  if (item === "waiting_payment")
    return i18n.tc(LocalesFields.WaitingForPayment);
  if (item === "learning" || item === "approved")
    return i18n.tc(LocalesFields.TrainingInProgress);
  if (item === "cancelled" || item === "refused")
    return i18n.tc(LocalesFields.Canceled);
  if (item === "learning_finished")
    return i18n.tc(LocalesFields.TrainingCompleted);
  if (item === "documents_ready")
    return i18n.tc(LocalesFields.DocumentsPrepared);
  if (item === "completed") return i18n.tc(LocalesFields.Done);
  if (item === "success") return i18n.tc(LocalesFields.Successful);
  if (item === "not_success") return i18n.tc(LocalesFields.Unsuccessful);
  if (item === "fail") return i18n.tc(LocalesFields.Fail);
  return item;
};

export const progressStatusV2 = (status: ProgressStatus) => {
  if (status === ProgressStatus.Fail) return i18n.tc(LocalesFields.Fail);
  if (status === ProgressStatus.Learning)
    return i18n.tc(LocalesFields.Learning);
  if (status === ProgressStatus.Pause) return i18n.tc(LocalesFields.Pause);
  if (status === ProgressStatus.Success)
    return i18n.tc(LocalesFields.Successful);
  if (status === ProgressStatus.Abort) return i18n.tc(LocalesFields.Canceled);
  return status;
};

export const availableStatuses = () => {
  return [
    "not_processed",
    "waiting_payment",
    "learning",
    "learning_finished",
    "documents_ready",
    "completed",
    "cancelled"
  ];
};

// not_processed,
// waiting_payment,
// learning,
// cancelled,
// learning_finished,
// documents_ready,
// completed
